import { createSlice } from "@reduxjs/toolkit"

const allAdSetsSlice = createSlice({
   name: "allAdSets",
   initialState: {
      allAdSets: null,
      getAllAdSetsLoading: false
   },
   reducers: {
      getAllAdSetsLoading: (state) => {
         state.getAllAdSetsLoading = true
      },
      getAllAdSetsSuccess: (state, action) => {
         state.allAdSets = action.payload
         state.getAllAdSetsLoading = false
      },
      getAllAdSetsFailure: (state) => {
         state.getAllAdSetsLoading = false
      }
   }
})

export const {
   getAllAdSetsLoading,
   getAllAdSetsSuccess,
   getAllAdSetsFailure,
} = allAdSetsSlice.actions

export default allAdSetsSlice.reducer
